import { Injectable, Injector } from '@angular/core';
import { NG1_AGENT_HISTORY } from '@commons/core/core.provider.ajs';
import { ModalService } from '@commons/core/ui/modal/modal.service';
import { TimelineEntry } from '@commons/history/timeline/models/timeline-entry';
import { IContactEntry } from '@commons/models/contact-entry';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { ActivityMonitoringAction, Option, ToasterFacade, TranslateService } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class ActivityMonitoringEffect {
  /**
   * Initialize success effect
   */
  openHistoryPopIn$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ActivityMonitoringAction.OpenHistory),
        // refresh basket
        tap(({ id }) => this.openHistoryPopInActionRequest(id))
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly injector: Injector,
    private readonly translateService: TranslateService,
    private readonly modalService: ModalService,
    private readonly toasterFacade: ToasterFacade
  ) {}

  public openHistoryPopInActionRequest(requestId: string): void {
    this.injector
      .get(NG1_AGENT_HISTORY)
      .searchByEpticaRequestIds([requestId])
      .subscribe(interaction => {
        if (interaction && !!interaction.contactEntries && interaction.contactEntries.length > 0) {
          this.openHistoPopin(interaction.contactEntries[0]);
        } else {
          this.toasterFacade.alert({
            message: 'commons:activity_monitoring.no_history',
          });
        }
      });
  }

  private openHistoPopin(element: IContactEntry) {
    const modalParam = {
      keyboard: false,
      backdrop: false,
      fullscreen: true,
      ctrlKeyboard: true,
      component: 'contactContactViewHistoPopin',
      modalId: `histoModalInteraction_${element.contactUuid}`,
      title: `${this.translateService.instant('agent:contact.info.popin.title')} ${element.contactLastName} ${element.contactFirstName}`,
      resolve: {
        selectContactEntry: () => TimelineEntry.fromContactEntry(element),
        contactCalling: () => Option.of(undefined),
        checkVisibilityMail: () => Option.of(false),
        inProcessActionsAllowed: () => Option.of(true),
      },
    };

    this.modalService.open(modalParam);
  }
}
